import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogModalComponent } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { type_modal } from 'src/app/helpers/msg-modal.helper';
import { NavigationExtras, Router } from '@angular/router';
import { RoutersEnum } from 'src/app/grupo-ramos/enums/routers.enums';
import { SalesOportunitiesRequest } from '../services/sales-oportunities-request.service';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-clients-consult-multiproducts-gr',
  templateUrl: './clients-consult-multiproducts-gr.component.html',
  styleUrls: ['./clients-consult-multiproducts-gr.component.scss']
})
export class ClientsConsultMultiproductsComponent implements OnInit {

  consultDataForm!: FormGroup;
  errorDisclaimer = false;
  isRight = false;
  isLoading = false;

  constructor(
    private readonly formBuild: FormBuilder,
    public  readonly dialog: MatDialog,
    public readonly router: Router,
    public readonly service: SalesOportunitiesRequest,
    private readonly authService: AuthService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.consultDataForm = this.initForm();
    this.autenticar();
  }

  async onSubmit(): Promise<void> {
    if (!this.isRight) {
      this.errorDisclaimer = true;
      return;
    }
    this.isLoading = true;
    try {
      const res = await this.service.clientsConsult(this.consultDataForm.value.documentId);
      if (res.isSucceded) {
        this.isLoading = false;
        const customerId = res.content.customerId;
        const isClient = res.content.isClient;
        const estadoCivil = res.content.estadoCivil;
        const sexo = res.content.sexo;
        const phone = res.content?.telefono;

        const navigationExtras: NavigationExtras = {
          state: {
            documentId: res.content.cedula, 
            fullName: `${res.content.nombre} ${res.content.apellido}`,
            phone,
            data: {
              firstName: res.content.nombre,
              lastName: res.content.apellido,
              customerId,
              isClient,
              estadoCivil,
              sexo,
            }
          }
        }
        await this.router.navigate([RoutersEnum.formMultiProducts],navigationExtras);
      }else{
        this.isLoading = false;
        await this.errorModal()
      }
    } catch (error) {
      this.isLoading = false;
      await this.errorModal()
      return console.log(error, `Error al obtener data de consult()`);
    }
  }
  private async errorModal(){
    await Swal.fire({
      icon: 'error',
      allowOutsideClick: false,
      confirmButtonColor: '#FFA400',
      title: "Aviso",
      text: 'No podemos validar tus datos en este momento. Para continuar, por favor visita tu sucursal APAP más cercana.'
    });
  }
  public openDialogRechazo(): void {
		this.dialog.open(DialogModalComponent, {
			data: type_modal.msgRechazarOferta,
		});
	}

  public toggleCheckDisclaimer(checked: boolean) {
    this.isRight = checked;
    this.errorDisclaimer = !checked;
  }

  isValidField(name: string): boolean {
    const fieldName = this.consultDataForm.get(name);
    return !!fieldName?.invalid && !!fieldName?.touched;
  }

  initForm(): FormGroup {
    return this.formBuild.group({
      documentId: ['', [Validators.required]],
    });
  }

  private autenticar() {
    this.authService.generateToken().subscribe((data: any) => {
      localStorage.setItem('token', data.content.token);
    });
  }

}
